var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12C3.4 12 2.5 12.9 2.5 14C2.5 15.1 3.4 16 4.5 16C5.6 16 6.5 15.1 6.5 14C6.5 12.9 5.6 12 4.5 12ZM4.5 10C5.6 10 6.5 9.1 6.5 8C6.5 6.9 5.6 6 4.5 6C3.4 6 2.5 6.9 2.5 8C2.5 9.1 3.4 10 4.5 10ZM6.5 2C6.5 3.1 5.6 4 4.5 4C3.4 4 2.5 3.1 2.5 2C2.5 0.899999 3.4 -2.71011e-07 4.5 -1.74846e-07C5.6 -7.86805e-08 6.5 0.9 6.5 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 12C10.4 12 9.5 12.9 9.5 14C9.5 15.1 10.4 16 11.5 16C12.6 16 13.5 15.1 13.5 14C13.5 12.9 12.6 12 11.5 12ZM11.5 10C12.6 10 13.5 9.1 13.5 8C13.5 6.9 12.6 6 11.5 6C10.4 6 9.5 6.9 9.5 8C9.5 9.1 10.4 10 11.5 10ZM13.5 2C13.5 3.1 12.6 4 11.5 4C10.4 4 9.5 3.1 9.5 2C9.5 0.899999 10.4 -2.71011e-07 11.5 -1.74846e-07C12.6 -7.86805e-08 13.5 0.9 13.5 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrip);
export default __webpack_public_path__ + "static/media/grip.c8bf62bb47c1e0a7835a1cf72d687c50.svg";
export { ForwardRef as ReactComponent };